enum googleMapActionType {
    GOOGLE_MAP_ADD_MARKER = 'GOOGLE_MAP_ADD_MARKER',
    GOOGLE_EDIT_SELECTED_MARKER = 'GOOGLE_EDIT_SELECTED_MARKER',
    GOOGLE_MAP_INIT_MARKER = 'GOOGLE_MAP_INIT_MARKER',
    GOOGLE_MAP_SET_MAP_BOUNDS = 'GOOGLE_MAP_SET_MAP_BOUNDS',
    GOOGLE_MAP_RESET_MAP_BOUNDS = 'GOOGLE_MAP_RESET_MAP_BOUNDS',
}

export default googleMapActionType